// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  configURL: {
    // public static apiUrl="https://webapisalix.azurewebsites.net/api/"

     API_AIRTEL_TEST:"http://35.195.95.65:8443/",

     API_AIRTEL_PROD:"https://developer.mycompay.com/"
    
   
}
          // config :
          //   {
          //     apiKey: "AIzaSyDYKx3ck8-GC14ushDuToYBR3o2hAwQJxE",
          //     authDomain: "salix-90588.firebaseapp.com",
          //     databaseURL: "https://salix-90588.firebaseio.com",
          //     projectId: "salix-90588",
          //     storageBucket: "",
          //     messagingSenderId: "77177038730",
          //     appId: "1:77177038730:web:e5f5da2ffe34c549fe8a73",
          //     measurementId: "G-YCYNP0MDNJ"
          //   }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
